import React, { FunctionComponent } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
// import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_one, fetch_all } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';
import { currentPracticeAtom } from '../../lib/practice';

// import {
//   Box,
//   Divider,
//   Grid,
//   Paper,
//   Tab,
//   Tabs,
// } from '@mui/material';

import {
  Page
} from '../../components/v2/styled';
import { Inbox } from '../../components/v2/Inbox';

import HelpersPractice from '../../actions/helpers/practice';

// const { DateTime } = require("luxon");

type Props = {}

export const NutriMail: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  // const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  const is_nutri_mail = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'nutri_mail'});

  // const [currentTab, setCurrentTab] = useState<number>(!!state && !!state.tab ? state.tab : 0);
  
  return <Page
    premiumGatekeeping={login?.type === "User::Admin" || login?.type === "User::User" || login?.type === "User::Restricted" || (login?.type === "User::Coach" && !!is_nutri_mail)}
    premiumMode='nutri_mail'
    sx={{padding: {xs: 0, md: 3}}}
  >
    <Inbox />
  </Page>;
}

